import { faCalendarDay, faClose, faFilter, faListAlt } from "@fortawesome/free-solid-svg-icons"
import Animate, { AnimationTypes } from "../../../components/Animate/Animate"
import ModalPortal from "../../../components/Modal/ModalPortal"
import { TitlePageResponsiveIconSmall } from "../../../components/Titles/Titles"
import { CourierPaymentRecord } from "../../../Objects/DeliveryEntity/CourierPaymentRecord"
import defaultStyle from "../../../styles/defaultPageStyle.module.css"
import THEME from "../../../configuration/Theme"
import { SIZE } from "../../../configuration/Sizes"
import Button, { ButtonIcon } from "../../../components/Button/Button"
import InputField from "../../../components/InputField/InputField"
import { ECourierPaymentConfirmationStatus } from "../../../Enum/ECourierPaymentConfirmationStatus"

interface RestaurantPaymentStatementPupopProp {
  rows: CourierPaymentRecord[]
  filter: { startDate: string; endDate: string }
  onFilterChange: (value: { startDate: string; endDate: string }) => void
  onClose: () => void
  onSearch: () => void
}

export const RestaurantPaymentStatementPupop = ({
  rows,
  filter,
  onFilterChange,
  onClose,
  onSearch,
}: RestaurantPaymentStatementPupopProp) => {
  return (
    <ModalPortal>
      <div className={defaultStyle.overlay}>
        <Animate type={AnimationTypes.slideUpIn} duration="0.3s">
          <div className={defaultStyle.alert2}>
            <TitlePageResponsiveIconSmall
              title={"Extrato de pagamentos"}
              icon={faListAlt}
              boxShadow="none"
              iconColor={THEME.colors.iconBGColor}
              children={
                <ButtonIcon
                  sizeNumber={SIZE.buttonCloseIconSize}
                  bgColor={THEME.colors.buttonBGCloseColor}
                  iconColor={THEME.colors.buttonFGCloseColor}
                  icon={faClose}
                  onClick={onClose}
                  size="small"
                  descriptionKey="interactionDescriptions:pages.delivery.pupop.restaurantPaymentStatementPupop.button.onClose"
                />
              }
            />

            <div className="space-y-4 overflow-y-auto p-2">
              <div className="grid gap-3 md:grid-cols-[1fr_1fr_auto]">
                <InputField
                  title="Data inicial"
                  type="date"
                  value={filter.startDate}
                  onChange={(e) => onFilterChange({ ...filter, startDate: e.target.value })}
                  placeholder="Data inicial"
                  icon={faCalendarDay}
                  descriptionKey="interactionDescriptions:pages.delivery.pupop.restaurantPaymentStatementPupop.input.dataInicial"
                />

                <InputField
                  title="Data final"
                  type="date"
                  value={filter.endDate}
                  onChange={(e) => onFilterChange({ ...filter, endDate: e.target.value })}
                  placeholder="Data final"
                  icon={faCalendarDay}
                  descriptionKey="interactionDescriptions:pages.delivery.pupop.restaurantPaymentStatementPupop.input.dataFinal"
                />

                <div className="flex items-end">
                  <Button
                    bgColor={THEME.colors.buttonBGSaveColor}
                    label="Buscar extrato"
                    onClick={onSearch}
                    descriptionKey="interactionDescriptions:pages.delivery.pupop.restaurantPaymentStatementPupop.button.buscarExtrato"
                  />
                </div>
              </div>

              <Animate type={AnimationTypes.fadeInTraslate} duration="1.5s">
                <div className="overflow-hidden rounded-xl border border-slate-200">
                  <div className="hidden text-center grid-cols-[1.2fr_1fr_1fr_1fr_1.2fr] gap-3 bg-slate-50 px-4 py-3 text-xs font-bold uppercase text-slate-500 md:grid">
                    <span>Entregador</span>

                    <span>Pago em</span>

                    <span>Valor</span>

                    <span>Status</span>

                    <span>Observação</span>
                  </div>

                  <div className="divide-y divide-slate-200">
                    {rows.length === 0 && (
                      <Animate type={AnimationTypes.fadeInTraslate} duration="1.8s">
                        <div className="p-4 text-center text-sm text-slate-500">
                          Nenhum pagamento encontrado para o período informado.
                        </div>
                      </Animate>
                    )}

                    {rows.map((row, index) => (
                      <Animate key={index} type={AnimationTypes.fadeInTraslate} duration={`${0.2 + index}s`}>
                        <div className="grid gap-3 px-4 py-4 text-center text-sm md:grid-cols-[1.2fr_1fr_1fr_1fr_1.2fr] md:items-center">
                          <div>
                            <p className="font-semibold text-slate-900">{row.courierName}</p>

                            <p className="text-xs text-slate-500">
                              {row.courierEmail || row.courierPhone || "Sem contato adicional"}
                            </p>
                          </div>

                          <div className="text-[12px] font-bold">{row.paymentDate.toString().toReadableDate()}</div>

                          <div className="font-semibold text-slate-900">{row.amount.toMoney()}</div>

                          <div>
                            <span
                              className={`rounded-full px-3 py-1 text-xs font-bold ${row.confirmationStatus === ECourierPaymentConfirmationStatus.Confirmed ? "bg-emerald-50 text-emerald-700" : row.confirmationStatus === ECourierPaymentConfirmationStatus.Rejected ? "bg-red-50 text-red-700" : "bg-amber-50 text-amber-700"}`}
                            >
                              {row.confirmationStatus === ECourierPaymentConfirmationStatus.Confirmed && "Confirmado"}

                              {row.confirmationStatus === ECourierPaymentConfirmationStatus.Rejected && "Contestado"}

                              {row.confirmationStatus === ECourierPaymentConfirmationStatus.Pending && "Aguardando"}
                            </span>
                          </div>
                          <div className="text-slate-600">{row.notes || "Sem observações"}</div>
                        </div>
                      </Animate>
                    ))}
                  </div>
                </div>
              </Animate>
            </div>
          </div>
        </Animate>
      </div>
    </ModalPortal>
  )
}
